import styled from "styled-components";

export const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
	width: 100%;
`;

export const SectionCard = styled.section`
	display: flex;
	padding: 16px;
	flex-direction: column;
	gap: 16px;
	border-radius: 20px;
	background: var(--profile-page-wrapper-bg);
	border: 1px solid rgba(110, 113, 145, 0.12);
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);

	@media (min-width: 1024px) {
		padding: 22px;
		gap: 18px;
	}
`;

export const SectionTitle = styled.h2`
	margin: 0;
	color: var(--content-text-color);
	font-size: 17px;
	font-weight: 700;
	line-height: 24px;
	letter-spacing: 0.2px;
`;

export const SectionHeader = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	justify-content: space-between;
	gap: 14px;
	padding-bottom: 4px;
	border-bottom: 1px solid rgba(110, 113, 145, 0.12);
`;

export const ControlsPanel = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 8px;
`;

export const ControlsRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: flex-end;
	gap: 8px;
`;

export const ContentDivider = styled.div`
	height: 1px;
	width: 100%;
	background: linear-gradient(
		90deg,
		transparent 0%,
		rgba(110, 113, 145, 0.25) 50%,
		transparent 100%
	);
	margin: 4px 0;
`;

export const IntroText = styled.p`
	margin: 0;
	color: var(--secondary-text-color);
	font-size: 13px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.25px;
`;
